export default __webpack_public_path__ + "assets/instagram_verified.png";